module.exports = __webpack_public_path__ + "img/person.63f6cdb5.svg";